import { render, staticRenderFns } from "./CustomNotificationBar.vue?vue&type=template&id=529bd35b&scoped=true&"
import script from "./CustomNotificationBar.vue?vue&type=script&lang=ts&"
export * from "./CustomNotificationBar.vue?vue&type=script&lang=ts&"
import style0 from "./CustomNotificationBar.vue?vue&type=style&index=0&id=529bd35b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529bd35b",
  null
  
)

export default component.exports